import React, { Component } from 'react'
import { Button, Icon, Input, message } from 'utils/ui';
import { addNote } from '../api_calls/user';
import { observer } from 'mobx-react';
import UserStore from '../stores/UserStore';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';

const { TextArea } = Input;
@observer(['UserStore', 'AuthStore'])
 class AddNote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            note: "",
            modalOpen: false,
            submittingNewNote: false

        };
        this.onSubmitClick = this.onSubmitClick.bind(this);
    }

    onSubmitClick() {
        // console.log("submitting new note..." + this.state.note);
        const { UserStore, AuthStore } = this.props;
        let self = this;
        self.setState({ submittingNewNote: true });
        let user = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
        addNote(user, this.state.note, AuthStore.userAuth.auth.accessToken).then(() => {
            message.success("Note added");
            self.setState({ submittingNewNote: false, modalOpen: false });
            UserStore.refreshUser(AuthStore.userAuth.auth.accessToken);            
        });
    }

    render() {
        return (<div>
            <ModalShell
            className="register-modal"
            overlayClassName="register-modal-overlay"
            isOpen={this.state.modalOpen}
            onRequestClose={() => { (this.state.submittingNewNote ? console.log("tried to close") : this.setState({ modalOpen: false })) }}
            maxWidth={600}>
            <ModalBody title="New Note" subtitle="Capture personal preferences quickly">
            <div className="ui-modal-stack" style={{ textAlign: 'center' }}>
                <TextArea 
                onChange={(e) => { this.setState({ note: e.target.value }) }} 
                placeholder="I always like..." 
                autoSize={{ minRows: 3, maxRows: 6 }}
                style={{ fontSize: '16px', padding: '12px' }}
                />
                <div className="ui-modal-actions">
                <Button 
                    className="AppFont btn-submit ui-btn-success" 
                    style={{
                    minWidth: '120px',
                    height: '40px'
                    }} 
                    onClick={this.onSubmitClick} 
                    size="large">
                    <Icon type="check-circle" /> Submit
                </Button>
                <Button 
                    className="AppFont btn-cancel ui-btn-danger" 
                    style={{
                    minWidth: '120px',
                    height: '40px'
                    }} 
                    onClick={() => { this.setState({ modalOpen: false }) }} 
                    size="large">
                    <Icon type="close" /> Cancel
                </Button>
                </div>
            </div>
            </ModalBody>
            </ModalShell>
            <div>
            <div style={{
                ...this.props.divStyle,
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 12px',
                borderRadius: 6,
                color: '#fff',
                cursor: 'pointer',
                userSelect: 'none',
                fontWeight: 600,
                transition: 'opacity 0.2s',
                ':hover': {
                opacity: 0.9
                }
            }} onClick={() => this.setState({ modalOpen: true })} size="large">
                <Icon style={{fontSize: '16px'}} type="file-add" />
                <span>Add Note</span>
            </div>
            </div>
        </div>
        )
    }
}
export default AddNote;